<template>
    <v-container id="libromayor-caplp">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    class="alineacentro DatosMatriculado"
                    dark
                    color="success"
                  >
                    <strong>LIBRO MAYOR</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="6" lg="6">
                  <selector-cuenta ref="selcuentalibromayor"
                    @selCuenta="seleccionarcuenta" idseleccionado="0" soloimputables="1">
                  </selector-cuenta>
                </v-col>
                <v-col cols="12" md="2" lg="2">
                    <v-menu
                        v-model="menufdesde"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="fechalocalfdesde"
                            label="Desde"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            height="20px"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="filtros.desde"
                        @input="menufdesde = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="2" lg="2">
                    <v-menu
                        v-model="menufhasta"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="fechalocalfhasta"
                            label="Hasta"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            height="20px"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="filtros.hasta"
                        @input="menufhasta = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="2" lg="2">
                    <v-btn class="ma-2" fab dark x-small color="primary" @click="Filtrar" :disabled="!permisolectura">
                      <v-icon dark>
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                    <v-btn
                      class="ma-2"
                      dark
                      x-small
                      color="primary"
                      title="Imprimir o Exportar Listado"
                      @click="AbrirCuadroImprimirExportar"
                      :disabled="!permisolectura || lista.length===0"
                    >
                      <v-icon dark> mdi-printer </v-icon>
                    </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                    <div>
                    <v-data-table
                      :headers="columnas"
                      :items="lista"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                      }"
                      item-key="asiento"
                      class="elevation-1"
                      dense
                      no-data-text="Sin Registros"
                      multi-sort
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              small
                              @click="ConsultarAsiento(item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!permisolectura"
                            >
                              mdi-magnify
                            </v-icon>
                          </template>
                          <span>Ver Detalle del Asiento</span>
                        </v-tooltip>
                      </template>
                      <!-- <template v-slot:item.asifecha="{ item }">
                        {{fechaendmy(item.fecha)}}
                      </template> -->
                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-row class="text-center">
                            <v-col cols="12" md="7" lg="8" class="alineaderecha">
                                <strong>Total Mov. en el Período:</strong>
                                <br />
                                <strong>Saldo Mov. en el Período:</strong>
                                <br />
                                <strong>Saldo al {{fechaendmy(filtros.hasta)}}:</strong>
                            </v-col>
                            <v-col cols="12" md="2" lg="2" class="alineaizquierda">
                                {{totdebe}}
                                <br />
                                {{saldodebe}}
                                <br />
                                {{saldoaldebe}}
                            </v-col>
                            <v-col cols="12" md="3" lg="2" class="alineaizquierda">
                                {{tothaber}}
                                <br />
                                {{saldohaber}}
                                <br />
                                {{saldoalhaber}}
                            </v-col>
                        </v-row>
                    </div>
                </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
      <v-dialog v-model="dialogconsulta" max-width="1280">
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Consulta Asiento N° {{edited.numero}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                <v-btn
                    icon
                    dark
                    @click="dialogconsulta = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-list dense>
                <v-list-item>
                    <v-list-item-content class="textoNegrita">Fecha:</v-list-item-content>
                    <v-list-item-content class="align-end">
                        {{ edited.fecha }}
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content class="textoNegrita">Leyenda:</v-list-item-content>
                    <v-list-item-content class="align-end">
                        {{ edited.leyenda }}
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content class="textoNegrita">Tipo:</v-list-item-content>
                    <v-list-item-content class="align-end">
                        {{ edited.tipoasiento }}
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content class="textoNegrita">Detalles de Asiento:</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="textoNegrita">
                    <v-data-table
                        :headers="columnasdetalle"
                        :items="edited.detalles"
                        hide-default-footer
                        class="elevation-1"
                        dense
                        no-data-text="Sin Detalles"
                        sort-by="['idcuenta']"
                        >
                    </v-data-table>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="textoNegrita">
                    <p :class="edited.detalles.length>0 ? (edited.detalles.filter(f=> f.grupo===2)[0].debe-edited.detalles.filter(f=> f.grupo===2)[0].haber)!=0 ? 'textoNegritaRojo' : 'textoNegrita' : 'textoNegrita'"> Diferencia: {{ edited.detalles.length>0 ? edited.detalles.filter(f=> f.grupo===2)[0].debe-edited.detalles.filter(f=> f.grupo===2)[0].haber : '' }}</p>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogverexportar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> Exportar Listado </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="alineaizquierda">
                <v-select
                  v-model="formatosel"
                  :items="listaformatos"
                  label="Formato"
                  outlined
                  item-text="formato"
                  item-value="formato"
                  dense
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="exportarlistado">
              Exportar
            </v-btn>
            <v-btn color="red darken-1" text @click="dialogverexportar = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorCuenta from "../../components/SelectorCuenta.vue";
export default {
  name: "LibroMayor",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorCuenta
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 53,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      filtros: {
        idcuenta: 0,
        desde: '',
        hasta: '',
        usuario: ''
      },
      menufdesde: false,
      menufhasta: false,
      columnas: [
        {
          text: "Op.",
          value: "actions",
          width: 30,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fecha",
          width: 60,
        },
        {
          text: "Asiento",
          align: "center",
          sortable: true,
          value: "numero",
          width: 50,
        },
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "descripcion",
          width: 90,
        },
        {
          text: "Leyenda",
          align: "center",
          sortable: true,
          value: "leyenda",
          width: 320,
        },
        {
          text: "Debe",
          align: "center",
          sortable: true,
          value: "debe",
          width: 80,
        },
        {
          text: "Haber",
          align: "center",
          sortable: true,
          value: "haber",
          width: 80,
        },
        {
          text: "Saldo",
          align: "center",
          sortable: true,
          value: "saldo",
          width: 110,
        }
      ],
      lista: [],
      totdebe: 0.00,
      tothaber: 0.00,
      saldodebe: 0.00,
      saldohaber: 0.00,
      saldoaldebe: 0.00,
      saldoalhaber: 0.00,
      edited: {
        numero: 0,
        fecha: '',
        tipoasiento: '',
        leyenda: '',
        detalles: []
      },
      dialogconsulta: false,
      columnasdetalle: [
        {
          text: "N° Cuenta",
          align: "center",
          sortable: true,
          value: "cuentanumero",
          width: 100,
        },
        {
          text: "Cod.",
          align: "center",
          sortable: true,
          value: "cuentacodigo",
          width: 80,
        },
        {
          text: "Descrip.",
          align: "center",
          sortable: true,
          value: "cuentadescripcion",
          width: 150,
        },
        {
          text: "Debe",
          align: "center",
          sortable: true,
          value: "debe",
          width: 90,
        },
        {
          text: "Haber",
          align: "center",
          sortable: true,
          value: "haber",
          width: 90,
        },
        {
          text: "DH",
          align: "center",
          sortable: true,
          value: "damdebehaber",
          width: 70,
        }
      ],
      dialogverexportar: false,
      listaformatos: [{ formato: "PDF" }, { formato: "EXCEL" }],
      formatosel: "PDF",
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    this.iddelegacionusuario = localStorage.getItem("iddelegacion");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var roles = localStorage.getItem("rolesusuario");
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 9).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion > 1 && p.idaccion < 9).length > 0 ? true : false;
      // this.CompletaCombos();
      this.filtros.usuario= this.usuario;
      this.loading= false;
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    seleccionarcuenta (value) {
      if(value!=null){
        this.filtros.idcuenta= value.cuenta;
      }else{
        this.filtros.idcuenta= 0;
      }
    },
    Filtrar () {
      if (this.filtros.idcuenta!=null && this.filtros.idcuenta!=0){
        this.loading= true;
        const params = this.filtros;
        axios.post('contabilidad/PostLibroMayor', params).then((result) => {
          if(result.data.resultado===0){
            this.lista = result.data.datos[0];
            this.totdebe= result.data.datos[1].totdebe;
            this.tothaber= result.data.datos[1].tothaber;
            this.saldodebe= result.data.datos[1].saldodebe!=null ? result.data.datos[1].saldodebe : '';
            this.saldohaber= result.data.datos[1].saldohaber!=null ? result.data.datos[1].saldohaber : '';
            this.saldoaldebe= result.data.datos[1].saldoaldebe!=null ? result.data.datos[1].saldoaldebe : '';
            this.saldoalhaber= result.data.datos[1].saldoalhaber!=null ? result.data.datos[1].saldoalhaber : '';
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje,false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error,false);
        })
      }else{
        this.loading = false;
        this.MostrarMensaje('Error', 'Seleccione una cuenta!',false);
      }
    },
    fechaendmy: function (fechaymd) {
        if(fechaymd!=null && fechaymd!='')
        {
          var fecha=new Date(fechaymd)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
    },
    ConsultarAsiento (item) {
      this.loading=true;
      const params = {numero: item.asiento};
      axios.post('contabilidad/PostLibroMayorDetaAsiento', params)
        .then((result) => {
          if(result.data.resultado===0){
            this.edited={
                numero: item.numero,
                fecha: item.fecha,
                tipoasiento: item.descripcion,
                leyenda: item.leyenda,
                detalles: result.data.datos
            };
            this.dialogconsulta=true;
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje('Error', result.data.resultadomensaje,false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje('Error', error,false);
        })

    },
    AbrirCuadroImprimirExportar () {
      this.dialogverexportar = true;
    },
    exportarlistado() {
      this.loading = true;
      var idcuenta= this.filtros.idcuenta.toString();
      var desde = this.filtros.desde != "" && this.filtros.desde != null ? this.filtros.desde : " ";
      var hasta = this.filtros.hasta != "" && this.filtros.hasta != null ? this.filtros.hasta : " ";
      var totdebe = this.totdebe!='' ? this.totdebe.toString() : '0';
      var tothaber = this.tothaber!='' ? this.tothaber.toString() : '0';
      var saldodebe = this.saldodebe!='' ? this.saldodebe.toString() : '0';
      var saldohaber = this.saldohaber!='' ? this.saldohaber.toString() : '0';
      var saldoaldebe = this.saldoaldebe!='' ? this.saldoaldebe.toString() : '0';
      var saldoalhaber = this.saldoalhaber!='' ? this.saldoalhaber.toString() : '0';
      var titulo = 'Libro Mayor';
      var subtitulo = 'Período ' + this.fechaendmy(desde) + ' a ' + this.fechaendmy(hasta);
      axios.post("reportes/GetReporte", {idreporte: 32, formato: this.formatosel,
            listaparametros: [
              { orden: 1, nombre: 'idcuenta', valor: idcuenta },
              { orden: 2, nombre: 'desde', valor: desde },
              { orden: 3, nombre: 'hasta', valor: hasta },
              { orden: 4, nombre: 'totdebe', valor: totdebe },
              { orden: 5, nombre: 'tothaber', valor: tothaber },
              { orden: 6, nombre: 'saldodebe', valor: saldodebe },
              { orden: 7, nombre: 'saldohaber', valor: saldohaber },
              { orden: 8, nombre: 'saldoaldebe', valor: saldoaldebe },
              { orden: 9, nombre: 'saldoalhaber', valor: saldoalhaber },
              { orden: 10, nombre: 'titulo', valor: titulo },
              { orden: 11, nombre: 'subtitulo', valor: subtitulo },
              { orden: 12, nombre: 'usuario', valor: this.usuario }
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
},
  computed: {
    fechalocalfdesde: function () {
      if(this.filtros.desde!=null && this.filtros.desde!='')
      {
        var fecha=new Date(this.filtros.desde)
        fecha.setDate(fecha.getDate()+1)
        return fecha.toLocaleDateString('es-AR')
      }else{
        return ''
      }
    },
    fechalocalfhasta: function () {
      if(this.filtros.hasta!=null && this.filtros.hasta!='')
      {
        var fecha=new Date(this.filtros.hasta)
        fecha.setDate(fecha.getDate()+1)
        return fecha.toLocaleDateString('es-AR')
      }else{
        return ''
      }
    },
  },
};
</script>
<style>
.filadeuda td {
    color: red;
}

.filadescuento td {
    color: green;
}

.filatotal td {
    color: blue;
}

.titulocardchico {
  padding: 8px !important;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa45 {
  width: 45%;
}
.ocupa50 {
  width: 50%;
}
.ocupa60 {
  width: 60%;
}
.ocupa75 {
  width: 75%;
}
.ocupa80 {
  width: 80%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  color: white;
  background-color: dimgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegrita {
  font-weight: bold !important;
}
.textoNegritaTitulo {
  font-weight: bold !important;
  font-size: medium;
}
.textoNegritaMontos {
  font-weight: bold !important;
  font-size: 12pt;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
.container {
  max-width: unset !important;
}
</style>
